import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  max-height: 128px;
  margin-top: 24px;
  gap: 16px;
  overflow-y: auto;
`;
